import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

import { StyledAddSignalButtonWrapper } from "../../buttons/AddSignalButton/styles";
import { StyledSignal } from "../../shared/Signal/styles";
import { StyledSignalTypesList } from "../../shared/SignalTypesList/styles";

export const StyledScrollableSignalsList = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    min-height: 0;
`;

export const StyledSignalsWrapper = styled(FlexColumn)`
    height: 100%;

    & ${StyledSignal}, & ${StyledAddSignalButtonWrapper} {
        margin-top: 12px;
        margin-left: 60px;
        margin-right: 60px;
    }

    & ${StyledSignal}:first-child {
        margin-top: 20px;
    }

    & ${StyledAddSignalButtonWrapper} {
        margin-bottom: 24px;
    }
`;

export const StyledSignalsSection = styled.div`
    flex-grow: 1;
    overflow-y: hidden;
    position: relative;
`;

export const StyledContent = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    min-height: 0;

    & ${StyledSignalTypesList} {
        margin-left: 16px;
    }
`;

const StyledHeader = styled.div`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    padding: 12px 12px 0 12px;
`;

export const StyledIntentEmptyTopicStateWrapper = styled.div`
    display: flex;
    margin: 20px 36px 0 34px;
`;
